import { useDispatch } from "react-redux";
import MessagePublisherAction from "@/core/actions/common/MessagePublisherAction";


type TUseContentIn = {
    unqKey:string;
}

type TUseSearchOut = {
    _showMessage: ( message:string ) => void;
}

const useMessage = ( props:TUseContentIn ):TUseSearchOut => {
    const dispatch = useDispatch();

    const messagePublisherAction = new MessagePublisherAction(dispatch);

    const _showMessage = ( message:string ) => {
        messagePublisherAction.showSuccessMessage(message);
    }

    return {
        _showMessage
    }
}

export default useMessage;
